define("SDB.PLP.Modifications.SS2Model", [
  "SCModel",
  "Utils",
  "Item.Collection",
  "MasterOptionsHelper",
  "Backbone.CachedModel",
  "Singleton",
], function (
  SCModelComponent,
  Utils,
  ItemCollection,
  MasterOptionsHelper,
  BackboneCachedModel,
  Singleton
) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;
  var original_fetch = BackboneCachedModel.prototype.fetch;
  var SDBPLPModificationsSS2Model = function SDBPLPModificationsSS2Model(
    options
  ) {
    SCModel.call(this);
    this.options = options || {};
    // this.set({ items: new ItemCollection(), total: 0, facets: [] }, { wait: true });

    // if (options && options.searchApiMasterOptions) {
    //     this.searchApiMasterOptions = options.searchApiMasterOptions;
    // } else {
    //     this.searchApiMasterOptions = MasterOptionsHelper.MasterOptionsHelper.getSearchAPIMasterOption('Facets');
    // }

    this.urlRoot = function () {
      var url = Utils.getAbsoluteUrl(
        getExtensionAssetsPath(
          "Modules/SDBPLPModifications/SuiteScript2/SuiteDB.PLP.Modifications.Service.ss"
        ),
        true
      );

      return url;
    };

    this.fetch = function (options) {
      Utils.deepExtend(
        options || {},
        _.omit(this.options, "container", "translator")
      );

      // if (_.isUndefined(options.cache)) {
      //     options.cache = true;
      // }

      // options.cache = !this.ignoreCache;

      return original_fetch.apply(this, arguments);
    };

    // this.parse = function parse(data) {
    //     var parsedResponse = {};

    //     if (data && typeof data === 'string') {
    //         parsedResponse = JSON.parse(data.slice(0, data.lastIndexOf('}') + 1));
    //     }

    //     if (parsedResponse.isFacetsResponse) {
    //         delete parsedResponse.isFacetsResponse;

    //         var facets = _.union(this.get('currentFacets'), parsedResponse.facets);
    //         parsedResponse.currentFacets = facets;
    //         delete parsedResponse.facets;

    //         return parsedResponse;
    //     };

    //     var items = parsedResponse.items;

    //     if (!(items instanceof ItemCollection)) {
    //         parsedResponse.items = new ItemCollection(_.compact(items));
    //     }

    //     return parsedResponse;
    // }

    // this.setPLPItems = function setPLPItems(items) {
    //     var oldItems = this.get('items');
    //     var newItems = new ItemCollection(_.compact(items));
    //     if (newItems.length === 0) return;

    //     var missingItems = [];

    //     oldItems.each(function (oldItem) {
    //         var hasItem = newItems.get(oldItem.get('id'));
    //         if (!hasItem) missingItems.push(oldItem);
    //     });

    //     _.each(missingItems, function (missingItem) {
    //         var URLs = _.toArray(missingItem.get('keyMapping_images'));
    //         missingItem.set('itemimages_detail', { urls: URLs }, { silent: true });
    //     });

    //     if (missingItems.length > 0) newItems.add(missingItems);
    //     this.set({ items: newItems }, { silent: true, wait: true });
    // };
  };

  SDBPLPModificationsSS2Model.prototype = Object.create(SCModel.prototype);
  SDBPLPModificationsSS2Model.prototype.constructor =
    SDBPLPModificationsSS2Model;

  return _.extend(SDBPLPModificationsSS2Model, Singleton);
});
